import { useTenantUsers } from './hooks';

const TenantUsers = () => {
  const { List } = useTenantUsers();

  return <List />;
};

export default TenantUsers;
